const SvgIcon = ({ size='24', color='#fff'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <path d="M10.268 21a2 2 0 0 0 3.464 0M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"></path>
  </svg>
);

export default SvgIcon;

// const SvgIcon = ({ size='24', color='#fff'}) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     //width="19.2"
//     height={size}
//     fill={color}
//     version="1.1"
//     viewBox="0 -960 768 960"
//   >
//     <path
//       strokeWidth="1.2"
//       d="M0-144v-96h96v-336q0-99.6 60-177t156-101.4V-888q0-30 21-51t51-21 51 21 21 51v33.6q96 24 156 101.4t60 177v336h96v96zM384 0q-39.6 0-67.8-28.2T288-96h192q0 39.6-28.2 67.8T384 0M192-240h384v-336q0-79.2-56.4-135.6T384-768t-135.6 56.4T192-576Z"
//     ></path>
//   </svg>
// );
// 
// export default SvgIcon;
